import React, {useEffect, useContext } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { GlobalProvider, GlobalContext } from '@src/context/GlobalContext';
import LocaleProvider from '@src/components/LocaleProvider';
import RouterAuth from '@src/components/RouterAuth';
import { GLOBAL_REDUCER_TYPE } from '@src/context/enumerate';
import routeList from './router';
import './styles/App.scss';

const Root = () => {
  const { state: { theme }, dispatch } = useContext(GlobalContext);
  const routers = useRoutes(routeList);

  const setDeviceType = () => {
    const width = document.documentElement.clientWidth;
    if (width < 769) {
      dispatch({ type: GLOBAL_REDUCER_TYPE.SET_DEVICE_TYPE, payload: {deviceType:'mobile'} });
    } else {
      dispatch({ type: GLOBAL_REDUCER_TYPE.SET_DEVICE_TYPE, payload: {deviceType: 'pc'} });
    }
  }

  useEffect(() => {
    setDeviceType();
    window.addEventListener('resize', setDeviceType, false);
    return () => {
      window.removeEventListener('resize', setDeviceType, false);
    }
  },[])

  return (
    <div id="App" className={`App ${theme}`}>
      {routers}
    </div>
  )
}

function App() {
  return (
    <GlobalProvider>
      <LocaleProvider>
        <BrowserRouter>
          <RouterAuth>
            <Root />
          </RouterAuth>
        </BrowserRouter>
      </LocaleProvider>
    </GlobalProvider>
  );
}

export default App;
